import type { Task } from '../types/task.dto';
import type { TaskModel } from '../types/task.model';

export const toTaskModel = (dto: Task): TaskModel => {
	return {
		id: dto.id!,
		title: dto?.content?.title?.text ?? '',
		body: dto?.content?.body?.text ?? '',
		status: dto.data.status,
		percent_completed: dto.data.percent_completed,
		start: dto.config.start,
		end: dto.config.end,
		organizationId: dto.org_id!,
	};
};
